import { useContext } from 'react';
import { createContext } from 'react';

import { ProductSummaryNameProps } from '../@types/ProductSummaryNameProps';

export const ProductSummaryNameContext = createContext<ProductSummaryNameProps>({} as ProductSummaryNameProps);

ProductSummaryNameContext.displayName = 'ProductSummaryName';

const ProductSummaryNameProvider = (props: ProductSummaryNameProps) => (
	<ProductSummaryNameContext.Provider value={props}>{props.children}</ProductSummaryNameContext.Provider>
);

export const useProductSummaryName = () => {
	const context = useContext(ProductSummaryNameContext);

	return context;
};

export default ProductSummaryNameProvider;
